import Image from 'next/future/image'
import { useTranslation } from 'next-i18next'
import TotalRating from '../TotalRating'

export default function SellerHeader ({ company }) {
  const { t } = useTranslation(['seller', 'categories', 'services'])

  return (
    <div className="p-4 p-md-5 bg-light row align-items-center rounded-3">
      <div className="order-1 order-lg-0 col-12 col-lg-9">
        <div className="d-flex flex-column">
          <h1 className="fs-2 text-dark-blue fw-bold mb-0">{company.name}</h1>
          <div className="d-flex align-items-center">
            <TotalRating
              canRate={false}
              rating={company.rating}
              onRatingChange={() => {}}
            />
            <span className="d-block mt-1 ms-2">{company.rating}</span>
          </div>
        </div>
      </div>
      <div className="order-0 order-lg-1 col-3 mb-4 mb-lg-0 d-flex justify-content-end">
        {
          company.logo && company.logo.url && (
            <Image
              alt=""
              className="rounded"
              style={{ width: '100%', maxWidth: '240px', height: 'auto' }}
              src={company.logo.url}
              width={company.logo.width}
              height={company.logo.height}
            />
          )}
      </div>
      {
        company?.services && company?.services.length > 0 && (
          <div className="col-9 order-2">
            <h2 className="h5">{t('detail.offered_services')}</h2>
            <div className="d-flex flex-wrap gap-2">
              {
                company.services.map(service => (
                  <span
                    key={service.id}
                    className="badge border border-primary text-primary me-2"
                  >
                    {t(`enum.${service.service}`, { ns: 'services' })}
                  </span>
                ))
              }
            </div>
          </div>
        )
      }
      <div className="col-12 col-lg-9 mt-4 order-3">
        <div className="d-flex flex-wrap align-items-center gap-3">
          {
            company.product_count && (
              <a
                href="#sellerPlugins"
                className="btn btn-primary"
              >
                {company.product_count} CAD-Plugins ansehen
              </a>
            )
          }
          {
            (company.subscription_type !== 'NONE' && company.company_constraints.has_lead === true) && (
              <a
                href="#sellerContactForm"
                className="btn btn-outline-primary"
              >
                Hersteller kontaktieren
              </a>
            )
          }
        </div>
      </div>
      <div className="col-12 order-4 mt-3">
        <div className="d-flex justify-content-end">
          {
            company?.social_media && Object
              .keys(company.social_media)
              .filter(key => company.social_media[key] !== null && key !== '__typename')
              .map((key, index) => (
                <div
                  key={key}
                  className="me-2"
                >
                  <a
                    target="_blank"
                    href={company.social_media[key]}
                    rel="noreferrer"
                  >
                    <Image
                      src={`/images/icons/${key}.svg`}
                      width={20}
                      height={20}
                      alt={key}
                    />
                  </a>
                </div>
              ))
          }
        </div>
      </div>
    </div>
  )
}
